import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import type { RouteDefinition } from './types';
import { KeepAlivePaneThemeProvider } from './KeepAlivePaneThemeProvider';

const PaneLoadingFallback: React.FC = () => (
  <Box
    data-splash-exclude
    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 200 }}
  >
    <CircularProgress size={32} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} />
  </Box>
);

export interface PaneRouteContentProps {
  panePath: string;
  definition: RouteDefinition;
  frozenLocation: {
    pathname: string;
    search: string;
    hash: string;
    state: null;
    key: string;
  };
}

/**
 * Conteúdo da rota memoizado — evita re-render (e refetch) ao trocar de aba.
 */
export const PaneRouteContent = React.memo(function PaneRouteContent({
  panePath,
  definition,
  frozenLocation,
}: PaneRouteContentProps) {
  return (
    <KeepAlivePaneThemeProvider>
      <Routes location={frozenLocation}>
        <Route
          path={definition.path}
          element={
            <Suspense fallback={<PaneLoadingFallback />}>
              {definition.element}
            </Suspense>
          }
        />
      </Routes>
    </KeepAlivePaneThemeProvider>
  );
}, (prev, next) =>
  prev.panePath === next.panePath &&
  prev.definition.path === next.definition.path &&
  prev.frozenLocation.search === next.frozenLocation.search &&
  prev.frozenLocation.hash === next.frozenLocation.hash,
);
